import request from '@/utils/request'
/**
 *
 * 奖品详情管理
 *
 **/

// 获取列表接口
export const getPrizeDetailsList = (params: any) => {
  return request({
    url: '/prizeDetails/page',
    method: 'get',
    params
  })
}

// 修改---启用禁用接口
export const enableOrDisablePrizeDetails = (params: any) => {
  return request({
    url: `/prizeDetails/status/${params.status}`,
    method: 'post',
    params: { id:params.id,type: params.type }
  })
}

// 新增---新建奖品详情
export const addPrizeDetails = (params: any) => {
  return request({
    url: '/prizeDetails',
    method: 'post',
    data: { ...params }
  })
}

// 新增---新建赛事规则详情
export const saveDocument = (params: any) => {
  return request({
    url: '/prizeDetails',
    method: 'post',
    data: { ...params }
  })
}

// 修改---新建奖品详情
export const updatePrizeDetails = (params: any) => {
  return request({
    url: '/prizeDetails',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口
export const queryPrizeDetailsById = (id: string | (string | null)[]) => {
  return request({
    url: `/prizeDetails/${id}`,
    method: 'get'
  })
}

// 删除接口
export const deletePrizeDetails = (params) => {
  return request({
    url: '/prizeDetails',
    method: 'delete',
    params: { ids:params.ids}
  })
}
